exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hidden_header {\n\tdisplay: none;\n}\n", ""]);

// exports
